import {isKeyHotkey} from "is-hotkey";
import {IS_APPLE} from "../environment";
import React from "react";

export type HotKeyObject = {
    generic: string|string[],
    apple?: string|string[],
    windows?: string|string[],
};

export type HotKeyFunction = (event: React.KeyboardEvent) => boolean;

export type HotKeyType = HotKeyObject|HotKeyFunction;

export const hotKeyAction = (hotKey: HotKeyType) => (hotKey ? (event: React.KeyboardEvent) => {
    if (hotKey instanceof Function) {
        return hotKey(event);
    } else {
        hotKey = hotKey as HotKeyObject
        const isGeneric = hotKey?.generic && isKeyHotkey(hotKey.generic)
        const isApple = hotKey?.apple && isKeyHotkey(hotKey.apple)
        const isWindows = hotKey?.windows && isKeyHotkey(hotKey.windows)

        if (isGeneric && isGeneric(event)) return true
        if (IS_APPLE && isApple && isApple(event)) return true
        if (!IS_APPLE && isWindows && isWindows(event)) return true
        return false
    }
} : undefined);